export const MuiDataGrid = {
  styleOverrides: {
    root: {
      '& .MuiDataGrid-cell': {
        display: 'flex',
        alignItems: 'center', // Align cell content vertically
      },
      '& .MuiDataGrid-columnHeader': {
        backgroundColor: 'var(--mui-palette-background-level1)',
        color: 'var(--mui-palette-text-secondary)',
      },
    },
  },
};
